import { JsonResponse, Nullable } from '@client/core/data/concerns/parses-from-json';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { parseISO } from '@client/core/utils/date';

/**
 * @see app/Http/Resources/Subscription/SubscriptionResource.php
 */
export class Subscription {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly stripeId: string,
    public readonly stripeStatus: string,
    public readonly stripePlan: string,
    public readonly stripePrice: string,
    public readonly quantity: number,
    public readonly trialEndsAt: Nullable<Date>,
    public readonly planText: Nullable<string>,
    public readonly endsAt: Nullable<Date>,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {}
}

defineTransform(Subscription, (json: JsonResponse, { fromSnakeCaseKeys, nullOr }) => {
  return {
    ...fromSnakeCaseKeys(),
    trialEndsAt: nullOr(json.trial_ends_at, () => parseISO(json.trial_ends_at)),
    endsAt: nullOr(json.ends_at, () => parseISO(json.ends_at)),
    createdAt: parseISO(json.created_at),
    updatedAt: parseISO(json.updated_at),
  };
});
